import { render, staticRenderFns } from "./MaintenanceAddCategoryDialog.vue?vue&type=template&id=05709af4&"
import script from "./MaintenanceAddCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./MaintenanceAddCategoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports